import React, { useEffect, useState } from 'react';
import DisplayLongDescriptionAndVariantMFRName
    from "../../../../component/Product/DisplayLongDescriptionAndVariantMFRName"
import AddToCart from "../../../../component/Global/Cart/AddToCart"
import QuantityPicker from "../../../../component/Global/Cart/QuantityPicker"
import store from "../../../../storeWire";
import { system_notification } from "../../../../store/slice/system";
import ProductCompareSelection from "../../../../component/Product/ProductCompareSelection";
import ProductInventoryRepository from "../../../../repository/ProductInventoryRepository";
import DisplayQtyMinQtyMult from "../../../../component/Product/DisplayQtyMinQtyMult";
import PriceTable from "../../../../component/Global/Cart/PriceTable";
import ProductPricingRepository from "../../../../repository/ProductPricingRepository";
import liveAuth from 'src/helper/liveAuth';
import { NonLoginSignInButton } from 'src/reusable/global';
import useReduxState from "../../../../hooks/useReduxState";
import AxiosIndicatorRunTimeLoader from "../../../../component/AxiosIndicatorRunTimeLoader";
import Helper from 'src/support/Helper';
import { useProductStore } from 'src/hooks/product';
import ProductListing from 'src/model/ProductListing';
import FadeInOut from "../../../../component/FadeInOut";
import CartCommon from "src/component/Global/Cart/Common";
import CommonCart from "../../../../component/Global/Cart/Common";
import { useCartStore } from 'src/hooks/cart';
import { isNumber, isEqual } from 'underscore';
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';
import useDebounce from "../../../../hooks/useDebounce";
import { useProductPricingStore } from 'src/hooks/productPricing';
import System from 'src/helper/system';
import Common from 'src/component/Global/Cart/Common';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import { useSelector } from 'react-redux';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import ProductInventoryDisplay from "../../../../component/Global/Product/ProductInventoryDisplay";
import Constants from "../../../../support/Constants";


const ProductDetailAlternativeTab = (props) => {
    const [productList, setProductList] = useDebounce([], 200);
    const [loading, set_loading] = useState(false);
    const [alt_product_API_call] = useReduxState(false, 'alt_product_API_call');
    const [subAltShowProductCount, setSubAltShowProductCount] = useState(5);
    const [productInventoryList, setProductInventoryList] = useState([]);
    const [{ productDetail, alternative_product_data, alternative_product_count }, { fetch_alternative_product_by_variant_number_list }, { }] = useProductStore();
    const [orderby, setOrderby] = useState('');
    const [orderbyDirection, setOrderbyDirection] = useState('asc');
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
    const [{ pricingList }, { fetch_product_pricing_list }, { }] = useProductPricingStore();
    const compareProductList = useSelector((state) => state.entities.model_ProductCompare.data, isEqual);
    const pricing = pricingList
    const [_check_p] = useCheckAuthPermissions();

    let c = System.getParams();

    const getCartProductInventoryQuantityByERPPartNumber = (ERPPartNumber, getObject = false) => {
        if (productInventoryList && productInventoryList[ERPPartNumber] !== undefined && productInventoryList[ERPPartNumber].quantity !== undefined) {
            if (getObject) {
                return productInventoryList[ERPPartNumber];
            } else {
                return productInventoryList[ERPPartNumber].quantity;
            }
        }
        return 0;
    };

    const fetchFromServer = async () => {
        let products = new ProductListing().toObjectWithItemNumber(alternative_product_data)
        await setProductList(products);
        await fetchProductInventoryFromServer(products);
    };


    // DT - 13141 - 14/8/23 - Inventory and price calls are made sequentially instead of parallel
    const fetchProductInventoryFromServer = async (products = false) => {
        set_loading(true)
        if (!products) {
            products = productList;
        }

        let inventory = {};

        // Restrict Pricing For Auth Account Less User
        if (validateNonLoginUser()) {
            inventory = await new ProductInventoryRepository().fetchProductInventoryByProducts(products);
        }
        else {
            await Promise.all([
                new ProductInventoryRepository().fetchProductInventoryByProducts(products),
                fetchProductPricingFromServer(products)
            ]).then((res) => {
                inventory = res[0];
            }).catch(() => { });
        }


        setProductInventoryList(inventory)
        set_loading(false)
    };

    const fetchProductPricingFromServer = async (products = false) => {
        // set_loading(true)
        // if (!products) {
        //     products = productList;
        // }

        if (products && Object.entries(products).length > 0) {
            let params = [];
            Object.entries(products).map((v) => {
                let _isManual = true;
                if (Helper.valueIsNotNull(c.searchTerm))
                    _isManual = Common.isCpnIsManual(v, c.searchTerm);

                params.push({
                    partNumber: v[1]?.ERPPartNumberModified ? '' : v[1].ERPPartNumber,
                    erpManufacturerCode: v[1].ERPManufacturerCode,
                    erpMfrPartNumber: v[1].ERPMFRPartNumber,
                    WebCode: v[1].WebCode,
                    ObsoleteFlag: v[1].ObsoleteFlag,
                    //  Qas: getInventory(v[1].ERPPartNumber)?.qas,
                    customerPartNumber: !_isManual ? Helper.toUpperCase(c.searchTerm) : undefined // 14790
                })

            });

            let paramSet = await new ProductPricingRepository().getPricingParams(params);
            await fetch_product_pricing_list(paramSet)
        }
        // set_loading(false)
    };

    const authLoggedIn = () => {
        return liveAuth.check();
    };

    const getOrderByClass = (columnName) => {
        if (columnName === orderby) {
            return 'sorting sorting_' + orderbyDirection
        }
        return 'sorting'
    };

    const toggleOrderBy = async (columnName) => {
        let d = orderbyDirection;
        if (d === 'desc') {
            d = 'asc';
        } else if (d === 'asc') {
            d = 'desc';
        }
        setOrderbyDirection(d);
        setOrderby(columnName);
    };

    useEffect(() => {
        async function fetchHere() {
            await getAlternativeProductByVariantNumber();
        }

        if (alt_product_API_call !== false) {
            fetchHere()
        }
    }, [orderby, orderbyDirection])

    useEffect(() => {
        async function fetchHere() {
            await getAlternativeProductByVariantNumber()
        }

        if (alt_product_API_call !== false) {
            fetchHere()
        }
    }, [alt_product_API_call]);

    useEffect(() => {
        async function fetchHere() {
            await fetchFromServer()
        }

        if (alt_product_API_call !== false) {
            fetchHere()
        }
    }, [alternative_product_data]);

    const getAlternativeProductByVariantNumber = async (getNewCount = false) => {
        set_loading(true)
        if (getNewCount === false) {
            getNewCount = subAltShowProductCount;
        }
        await fetch_alternative_product_by_variant_number_list({
            ItemNum: productDetail.value.ItemNumber,
            orderBy: ((orderby !== '' ? orderby : 'ManufacturerPartNumber') + ' ' + orderbyDirection),
            top: getNewCount > 5 ? getNewCount : 5,
            skip: 0
        })
        set_loading(false)
    }

    const getInventory = (ERPPartNumber) => {
        return get_inventory_by_id(ERPPartNumber);
    };

    const getPricing = (ERPMFRPartNumber, ERPPartNumber,ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber;
        if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber] !== undefined) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return [];
    };

    const displayPricingBasedOnSingleProduct = (v) => {
        if (!new CartCommon().getDisplayStatusOfPricingTable(getInventory(v.ERPPartNumber), v)) {
            return false;
        }
        let p;
        if (CART_BEFORE_TO_SEND_SERVER[v.ItemNumber] === undefined) {
            p = Number(parseFloat(new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified), v.QtyMult).marketPrice * v.QtyMin).toFixed(3));
        } else {
            p = Number(parseFloat(new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified), CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityAddToCart).marketPrice * CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityAddToCart).toFixed(3));
        }
        if ((isNumber(p) && !isNaN(p)) === false) {
            return false;
        }
        return (
            <>
                {(isNumber(p) && !isNaN(p)) ? Helper.getFormatNumber(p, window.mct, window.mcs, 2, true, false) : ''}
            </>
        );
    };

    const checkProductTitleMatch = (product) => {
        if (product) {
            if (
                product.VendorPartNumber &&
                product.ERPMFRPartNumber
            ) {
                return product.ERPMFRPartNumber == product.VendorPartNumber;
            }
        }
        return false;
    };

    const isGuestFullRights = () => {
        return (_check_p('PDG_ADD_TO_CART').status &&
            _check_p('PDG_ADD_TO_BOM').status &&
            _check_p('PDG_CLICK_TO_QUOTE').status);
    }

    const validateNonLoginUser = () => {
        if (!liveAuth.check()) {
            return true;
        }
        if (liveAuth.check() && isGuestFullRights() === false) {
            return true;
        }
        return false;
    }

    return (
        <>
            <div className="tab-pane fade" id="tab2">
                <h4 className='mt-0'>Subs/Alternatives</h4>
                <div className='d-md-block'>
                    {productList && Object.keys(productList).length === 0 &&
                        <AxiosIndicatorRunTimeLoader />
                    }
                    <>
                        <div
                            className="product-table product-table-striped products-table-wrapper table-responsive">
                            {productList && Object.keys(productList).length > 0 &&
                                <FadeInOut show={true} duration={500}>
                                    <table className="bs5 table table-bordered search-products-table mb-0">
                                        <thead>
                                            <tr>
                                                <th
                                                    className={'font-10  text-none ' +
                                                        getOrderByClass('ManufacturerPartNumber')
                                                    }
                                                    onClick={async () => {
                                                        await toggleOrderBy('ManufacturerPartNumber')
                                                    }}><span>PRODUCTS</span></th>
                                                <th className='font-10  text-none'><span>PRICE</span></th>
                                                <th className='font-10 text-none w300'>
                                                    <span>AVAILABILITY</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productList && Object.keys(productList).length > 0 && Object.keys(productList).map((v, i) => (
                                                <tr key={v}>
                                                    <td className="product-th additional-stock-wrapper mobile-block product-data minw-auto minw280">
                                                        <div className="col-12 nopadding product-td minw-auto">
                                                            <div className="bs5 row 0 flex-nowrap">
                                                                <div
                                                                    className="col-12 static-position product-info-sect-2 pe-3 tab-product-info">
                                                                    <div>
                                                                        <div>
                                                                            <div className="product-name">
                                                                                <div className="grey">
                                                                                    <NavigateToPDP data={{
                                                                                        ManufacturerName: productList[v]?.ManufacturerName,
                                                                                        ERPMFRPartNumber: productList[v]?.ERPMFRPartNumber,
                                                                                        ItemNumber: productList[v]?.ItemNumber,
                                                                                    }} >
                                                                                        <strong>{(productList[v].ERPMFRPartNumber !== undefined && productList[v].ERPMFRPartNumber !== null && productList[v].ERPMFRPartNumber.trim() !== '') ? productList[v].ERPMFRPartNumber : ''}</strong>
                                                                                    </NavigateToPDP>
                                                                                </div>
                                                                            </div>
                                                                            <div className="grey">
                                                                                <a>
                                                                                    <span className="grey">
                                                                                        <b>{(productList[v].ManufacturerName !== undefined && productList[v].ManufacturerName !== null && productList[v].ManufacturerName.trim() !== '') ? productList[v].ManufacturerName : ''}</b>
                                                                                    </span>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                        <DisplayLongDescriptionAndVariantMFRName
                                                                            currentProduct={productList[v]} />
                                                                    </div>
                                                                    <div
                                                                        className={checkProductTitleMatch(productList[v]) ? 'd-none' : ''}>
                                                                        <b>Also known as: </b>
                                                                        <span>{productList[v].VendorPartNumber !== undefined && productList[v].VendorPartNumber !== null && productList[v].VendorPartNumber !== "" ? productList[v].VendorPartNumber : ""}</span>
                                                                    </div>
                                                                    <div className="info-capsule mt-4">
                                                                        <div className="info-capsule-item">
                                                                            <ProductCompareSelection
                                                                                single_product={productList[v]}
                                                                                model_ProductCompare_data={compareProductList} />
                                                                        </div>
                                                                        {productList[v].DatasheetUrl &&
                                                                            <a rel="nofollow"
                                                                                href={productList[v].DatasheetUrl}
                                                                                target="_blank" className="info-capsule-item">
                                                                                <img className="img-fluid" alt="Datasheet" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEoSURBVHgBnZIxS8NAFMf/KYHgINzSRZCm3yCbY1v8Ck4uVgTnZnPTfgTBRZe4iEO0dHRxctTBLyCJi4OD3qBOwvW99lrS47hc++DPS17e/3cvLwGAgqQsivUzzs5QDoDygdQBnJAQ7hhWrmNSuQogMwwCnhOc6+YDo/5OGpvNDQvg1TgZSZIgz/OOUuqMlNQBBIxxGTBqvXT3n09O+dZngjEsC7OFCbjWJ7DaWkNfAC8vJbVIPGqhc8cFCCtjD7RhoGu8hz5qIsDsT5tDFgsSQiDLMvxuK4SbEW6+Hqb14/ae3GhEcre5UwZB0ONXKLVnabtSSqRpip//P1x+jqaZdVXcia2oyS2H8An67jGZvntPR4p1//FYcA2rBBm6F2+365krkL7NPAEy0HwqftdBcQAAAABJRU5ErkJggg" />
                                                                                <span
                                                                                    className="datasheet-label">Datasheet</span>
                                                                            </a>
                                                                        }
                                                                        <div className="info-capsule-item cursor-pointer"
                                                                            onClick={() => {
                                                                                store.dispatch(system_notification({
                                                                                    name: 'AddToBOMPopup',
                                                                                    data: {
                                                                                        single_product: productList[v],
                                                                                        addFrom: 'PDP'
                                                                                    }
                                                                                }));
                                                                            }}>

                                                                            <img className="img-fluid me-1" alt="BOM" src="data:image/png;base64,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" />
                                                                            <span
                                                                                className="datasheet-label">Add To BOM</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="price-th minw-auto w320">
                                                        {authLoggedIn() && !validateNonLoginUser() &&
                                                            <div className="price-td bs5 row flex-nowrap">
                                                                <div className="col price-table w180">
                                                                    <PriceTable
                                                                        linesToDisplay={3}
                                                                        single_product_inventory={getCartProductInventoryQuantityByERPPartNumber(productList[v].ERPPartNumber, true)}
                                                                        single_product={productList[v]}
                                                                        single_product_pricing_list={getPricing(productList[v].ERPMFRPartNumber, productList[v].ERPPartNumber, productList[v].ERPPartNumberModified)}
                                                                    />
                                                                </div>
                                                                <div className="col-auto">
                                                                    {displayPricingBasedOnSingleProduct(productList[v]) !== false &&
                                                                        <div className="price dense-hide mb-2">
                                                                            {window.mct === window.mcs &&
                                                                                <strong>
                                                                                    {window.mct} :
                                                                                </strong>
                                                                            }
                                                                            {window.mct !== window.mcs &&
                                                                                <strong>
                                                                                    {window.mct} <span>{window.mcs}</span>:
                                                                                </strong>
                                                                            }
                                                                            <div
                                                                                className="pull-right font-bold">
                                                                                <>
                                                                                    {displayPricingBasedOnSingleProduct(productList[v])}
                                                                                </>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div
                                                                        className="text-left small-text light light-text collapse_minmax">
                                                                        <DisplayQtyMinQtyMult
                                                                            single_product={productList[v]} />
                                                                    </div>

                                                                    {productList[v].ERPPartNumber !== undefined &&
                                                                        <>
                                                                            <div className="d-flex add-to-cart w-100">
                                                                                <QuantityPicker
                                                                                    single_product_pricing_list={getPricing(productList[v].ERPMFRPartNumber, productList[v].ERPPartNumber, productList[v].ERPPartNumberModified)}
                                                                                    single_product={productList[v]}
                                                                                    single_product_inventory={getCartProductInventoryQuantityByERPPartNumber(productList[v].ERPPartNumber, true)}
                                                                                />
                                                                            </div>
                                                                            <div className={'add-to-cart w-100'}>
                                                                                <AddToCart
                                                                                    single_product_pricing_list={getPricing(productList[v].ERPMFRPartNumber, productList[v].ERPPartNumber, productList[v].ERPPartNumberModified)}
                                                                                    single_product_inventory={getCartProductInventoryQuantityByERPPartNumber(productList[v].ERPPartNumber, true)}
                                                                                    single_product={productList[v]}
                                                                                    isFrom="PDP" />
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                        {validateNonLoginUser() &&
                                                            <NonLoginSignInButton isAuthAccLess={liveAuth.check() && isGuestFullRights() === false} />
                                                        }
                                                    </td>
                                                    <td>
                                                        <ul className="list-text availibility-list-text">
                                                            {productList[v] && <ProductInventoryDisplay single_product={productList[v]} isFrom={Constants.isFrom.PDP_ALT} single_product_inventory={get_inventory_by_id(productList[v]?.ERPPartNumber)}/>}
                                                        </ul>
                                                    </td>
                                                </tr>
                                            ))
                                            }
                                        </tbody>
                                    </table>
                                </FadeInOut>
                            }
                            {Object.keys(productList).length === 0 &&
                                <>
                                    <div className="tab-pane fade" id="tab2">
                                        No data Found
                                    </div>
                                </>
                            }
                        </div>
                        {(Object.keys(productList).length >= 5 && Object.keys(productList).length !== alternative_product_count) &&
                            <div className='text-right  mt-2'>
                                <a href={void (0)} onClick={async () => {
                                    setSubAltShowProductCount(Object.keys(productList).length + 5);
                                    await getAlternativeProductByVariantNumber(Object.keys(productList).length + 5);
                                }} className='text-blue2 font-bold'>
                                    {loading === true &&
                                        <AxiosIndicatorRunTimeLoader inline={true} />
                                    }
                                    {loading === false ? 'Show More' : ''}
                                </a>
                            </div>
                        }
                    </>
                </div>
            </div>
        </>
    );
};

export default ProductDetailAlternativeTab;